






































import { Component, Vue, Watch } from 'vue-property-decorator';
import Route from 'vue-router';
import ListMachines from '@/components/ListMachines.vue'; // @ is an alias to /src
import UploadMachines from '@/components/UploadMachines.vue';

// Service
import { Datasource } from '../services/datasource';

// Model
import { Machine } from '../models/machine';

@Component({
  components: {
    ListMachines,
    UploadMachines
  }
})
export default class Machines extends Vue { 

  page:number = -1

  machines: Machine[] = []
  total:number = 0
  // Data Placeholder
  source:Datasource = Datasource.shared
  pageSize:number = 30

  get lastPage() {
    return Math.ceil(this.total / this.pageSize)
  }

  mounted() {
    this.page = +(this.$route.params.page || 0)
  }

  gotoPage(page:number) {
    this.$router.push('/machines/' + page)
  }

  gotoNextPage() {
    this.gotoPage(Math.min(this.lastPage, +this.page + 1))
  }

  gotoPreviousPage() {
    this.gotoPage(Math.max(0, +this.page - 1))
  }

  @Watch('$route')
  onRouteUpdate(val:Route, newVal:Route) {
    this.page = +(this.$route.params.page || 0)
  }

  @Watch('page')
  onPageChanged(val:number, newVal:number) {
    console.log('page changed from', val, 'to', newVal)
    this.source.machines((val || 0) * this.pageSize, this.pageSize)
      .then(([machines, total]) => {
        this.machines = machines;
        this.total = total;
      })
      .catch(console.error)
  }
}
